export default "__VITE_ASSET__cdZ8TlYD__"